<div class="image-container">
    @defer (on viewport) {
        <img
            #image
            class="image-container__image"
            [alt]="altText"
            [class.image-container__image--portrait]="shouldContainImage$ | async"
            [class.image-container__image--loaded]="(isImageLoaded$ | async) === true"
            [src]="(basePath && imagePath) ? basePath + imagePath : (placeholderPath ?? '/assets/images/placeholder.png')"
            (load)="onImageLoaded($event)"
        >
    } @placeholder {
        <p-skeleton
            class="image-container__image image-container__image-placeholder"
            height="100%"
            borderRadius="0"
        />
    }
</div>
